module.exports = __webpack_public_path__ + "img/tiktok.5eb750bc.svg";